import { synapse } from '@ublique/platform'
import { BASE_URL } from 'config'

//OWL

export const getDashboardNowcastingData = async ({ scenarioId }) => {
  const url = `${BASE_URL}/output/${scenarioId}/dashboard`
  const response = await synapse.fetch(url)

  return response?.body
}
